<template>
    <div>
        <b-modal
            size="lg"
            v-model="modalShow"
            :title="`${$locale.consultation_host}メニュー追加`"
            @hidden="close">
            <form @submit.stop.prevent="addDoctorMenu">
                <div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group m-form__group">
                                <label
                                    for="name"
                                    class="is-required-ja">
                                    タイトル
                                </label>
                                <input
                                    v-model="doctorMenu.title"
                                    id="name"
                                    class="form-control m-input"
                                    :class="{ 'is-invalid' : errors.title }"
                                    type="text"
                                    placeholder="メニューのタイトルを入力してください">
                                <div
                                    v-if="errors.name"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors.name[0] }}
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="form-group m-form__group">
                                <div class="form-group m-form__group">
                                    <label
                                        for="medical_course_id"
                                        class="is-required-ja">
                                        {{ $locale.consultation_host }}科
                                    </label>
                                    <select
                                        v-model="doctorMenu.medical_course_id"
                                        id="medical_course_id"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.medical_course_id }">
                                        <option :value="null">{{ $locale.consultation_host }}科を選択してください</option>
                                        <option
                                            v-for="medicalCourse in doctor.medical_courses"
                                            :value="medicalCourse.id">{{ medicalCourse.name }}</option>
                                    </select>
                                    <div
                                        v-if="errors.medical_course_id"
                                        class="invalid-feedback d-block mt-1">
                                        {{ errors.medical_course_id[0] }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group">
                                <div class="form-group m-form__group">
                                    <h5>表示設定</h5>
                                    <div
                                        v-for="plan in selectablePlans"
                                        class="checkboxList">
                                        <div class="custom-control custom-checkbox">
                                            <input
                                                v-model="planIds"
                                                type="checkbox"
                                                :id="`plan_${plan.id}`"
                                                :key="`plan_${plan.id}`"
                                                :value="plan.id"
                                                class="custom-control-input"
                                                :disabled="inProgress">
                                            <label
                                                class="custom-control-label"
                                                :for="`plan_${plan.id}`">
                                                {{ planCheckLabel(plan) }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="checkboxList">
                                        <div class="custom-control custom-checkbox">
                                            <input
                                                v-model="isHideMatching"
                                                type="checkbox"
                                                id="is_matching"
                                                class="custom-control-input"
                                                :disabled="inProgress">
                                            <label
                                                class="custom-control-label"
                                                for="is_matching">
                                                マッチング予約に表示しない
                                            </label>
                                        </div>
                                    </div>

                                    <h5 class="mt-3">オプション設定</h5>
                                    <div class="checkboxList">
                                        <div class="custom-control custom-checkbox">
                                            <input
                                                v-model="doctorMenu.is_health_package"
                                                type="checkbox"
                                                id="is_health_package"
                                                class="custom-control-input"
                                                :disabled="inProgress">
                                            <label
                                                class="custom-control-label"
                                                for="is_health_package">
                                                健康管理パッケージにする（法人会員のみ表示）
                                            </label>
                                        </div>
                                    </div>
                                    <div class="checkboxList">
                                        <div class="custom-control custom-checkbox">
                                            <input
                                                v-model="doctorMenu.is_repeatable"
                                                type="checkbox"
                                                id="is_repeatable"
                                                class="custom-control-input"
                                                :disabled="inProgress">
                                            <label
                                                class="custom-control-label"
                                                for="is_repeatable">
                                                再{{ $locale.consultation_host }}可能メニューにする
                                            </label>
                                        </div>
                                    </div>
                                    <div class="checkboxList">
                                        <div class="custom-control custom-checkbox">
                                            <input
                                                v-model="doctorMenu.is_only_repeatable"
                                                type="checkbox"
                                                id="is_only_repeatable"
                                                class="custom-control-input"
                                                :disabled="inProgress || !doctorMenu.is_repeatable">
                                            <label
                                                class="custom-control-label"
                                                for="is_only_repeatable">
                                                再{{ $locale.consultation_host }}のみ可能にする
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="form-group m-form__group">
                                <div class="form-group m-form__group">
                                    <label
                                        for="consultation_minutes"
                                        class="is-required-ja">
                                        {{ $locale.consultation_host }}時間
                                    </label>
                                    <select
                                        v-model="doctorMenu.consultation_minutes"
                                        :disabled="doctorMenu.is_auto"
                                        id="consultation_minutes"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.consultation_minutes }">
                                        <option :value="null">{{ $locale.consultation_host }}時間を選択してください</option>
                                        <option
                                            v-for="min in consultationMinutes"
                                            :value="min">
                                            {{ `${min}分` }}
                                        </option>
                                    </select>
                                    <div
                                        v-if="errors.consultation_minutes"
                                        class="invalid-feedback d-block mt-1">
                                        {{ errors.consultation_minutes[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6">
                            <div class="form-group m-form__group">
                                <div class="form-group m-form__group">
                                    <label
                                        for="consultation_minutes"
                                        class="is-required-ja">
                                        バッファ時間（前）
                                    </label>
                                    <select
                                        v-model="doctorMenu.before_buffer"
                                        id="consultation_minutes"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.before_buffer }">
                                        <option :value="null">バッファ時間を選択してください</option>
                                        <option
                                            v-for="buffer in buffers"
                                            :value="buffer">
                                            {{ `${buffer}分` }}
                                        </option>
                                    </select>
                                    <div
                                        v-if="errors.before_buffer"
                                        class="invalid-feedback d-block mt-1">
                                        {{ errors.before_buffer[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6">
                            <div class="form-group m-form__group">
                                <div class="form-group m-form__group">
                                    <label
                                        for="consultation_minutes"
                                        class="is-required-ja">
                                        バッファ時間（後）
                                    </label>
                                    <select
                                        v-model="doctorMenu.after_buffer"
                                        id="consultation_minutes"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.after_buffer }">
                                        <option :value="null">バッファ時間を選択してください</option>
                                        <option
                                            v-for="buffer in buffers"
                                            :value="buffer">
                                            {{ `${buffer}分` }}
                                        </option>
                                    </select>
                                    <div
                                        v-if="errors.after_buffer"
                                        class="invalid-feedback d-block mt-1">
                                        {{ errors.after_buffer[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            v-if="$locale.type === 'consul'"
                            class="col-12">
                            <div class="form-group m-form__group">
                                <label
                                    for="name"
                                    class="is-required-ja">
                                    {{ $locale.consultation_host }}料（税抜）
                                </label>
                                <input
                                    v-model="doctorMenu.consultation_price"
                                    type="text"
                                    id="consultation_price"
                                    class="form-control m-input"
                                    :class="{ 'is-invalid' : errors.consultation_price }"
                                    :placeholder="`${$locale.consultation_host}料を税抜で入力してください`">
                                <div
                                    v-if="errors.consultation_price"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors.consultation_price[0] }}
                                </div>
                            </div>
                        </div>

                        <div
                            v-if="$locale.type === 'consul'"
                            class="col-12">
                            <div class="form-group m-form__group">
                                <label
                                    for="name"
                                    class="is-required-ja">
                                    医師手数料（税抜）
                                </label>
                                <input
                                    v-model="doctorMenu.commission"
                                    type="text"
                                    id="commission"
                                    class="form-control m-input"
                                    :class="{ 'is-invalid' : errors.commission }"
                                    placeholder="医師手数料を税抜で入力してください">
                                <div
                                    v-if="errors.commission"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors.commission[0] }}
                                </div>

                                <div class="custom-control custom-checkbox mt-2">
                                    <input
                                        v-model="doctorMenu.is_commission_tax"
                                        type="checkbox"
                                        id="is_commission_tax"
                                        class="custom-control-input"
                                        :disabled="inProgress">
                                    <label
                                        class="custom-control-label"
                                        for="is_commission_tax">
                                        医師手数料に消費税を含める
                                    </label>
                                </div>
                            </div>
                        </div>

                        <template v-if="doctorMenu.is_repeatable">
                            <div class="col-12">
                                <div class="form-group m-form__group">
                                    <label for="repeat_consultation_price">
                                        再{{ $locale.consultation_host }}時の{{ $locale.consultation_host }}料（税抜）
                                    </label>
                                    <input
                                        v-model="doctorMenu.repeat_consultation_price"
                                        type="text"
                                        id="repeat_consultation_price"
                                        class="form-control m-input"
                                        :class="{ 'is-invalid' : errors.repeat_consultation_price }"
                                        :placeholder="`再${$locale.consultation_host}時の${$locale.consultation_host}料を税抜で入力してください`">
                                    <div
                                        v-if="errors.repeat_consultation_price"
                                        class="invalid-feedback d-block mt-1">
                                        {{ errors.repeat_consultation_price[0] }}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="form-group m-form__group">
                                    <label for="repeat_commission">
                                        再{{ $locale.consultation_host }}時の医師手数料（税抜）
                                    </label>
                                    <input
                                        v-model="doctorMenu.repeat_commission"
                                        type="text"
                                        id="repeat_commission"
                                        class="form-control m-input"
                                        :class="{ 'is-invalid' : errors.repeat_commission }"
                                        :placeholder="`再${$locale.consultation_host}時の医師手数料を税抜で入力してください`">
                                    <div
                                        v-if="errors.repeat_commission"
                                        class="invalid-feedback d-block mt-1">
                                        {{ errors.repeat_commission[0] }}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="form-group m-form__group">
                                    <label
                                        for="name"
                                        class="is-required-ja">
                                        再{{ $locale.consultation_host }}までの日数
                                    </label>
                                    <div class="d-flex justify-content-start align-items-center">
                                        <div class="text-muted repeatReservableDaysPrefix">
                                            前回の{{ $locale.consultation_host }}日から
                                        </div>
                                        <input
                                            v-model="doctorMenu.repeat_reservable_days"
                                            type="text"
                                            id="repeat_reservable_days"
                                            class="form-control m-input repeatReservableDaysInput"
                                            :class="{ 'is-invalid' : errors.repeat_reservable_days }">
                                        <div class="text-muted repeatReservableDaysSuffix">
                                            日以内
                                        </div>
                                    </div>
                                    <div
                                        v-if="errors.repeat_reservable_days"
                                        class="invalid-feedback d-block mt-1">
                                        {{ errors.repeat_reservable_days[0] }}
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div class="col-12">
                            <div class="mb-3">
                                <label>ラベル</label>
                                <vue-tags-input
                                    v-model="doctorMenuLabel"
                                    :tags="doctorMenuLabels"
                                    @tags-changed="labels => syncDoctorMenuLabel(labels)"
                                    placeholder="ラベルを追加"
                                />
                                <div v-if="errors.doctor_menu_labels"
                                     class="invalid-feedback d-block">
                                    {{ errors.doctor_menu_labels[0] }}
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <label for="description">詳細</label>
                            <b-form-textarea
                                v-model="doctorMenu.description"
                                :rows="5"
                                id="description"
                                placeholder="メニューの詳細を入力してください">
                            </b-form-textarea>
                            <div v-if="errors.description"
                                 class="invalid-feedback d-block">
                                {{ errors.description[0] }}
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <div
                slot="modal-footer"
                class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
                <button
                    class="btn btn-yokumiru-orange float-right"
                    style="width:90px;"
                    :disabled="inProgress"
                    @click="handleOk">
                    追加
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../../constants'
    import VueTagsInput from '@johmun/vue-tags-input'

    export default {
        components: {
            VueTagsInput,
        },

        props: {
            doctor: {
                type: Object,
                required: true,
            },
        },

        data: function () {
            return {
                inProgress: false,
                modalShow: false,
                consultationMinutes: [15, 30, 45, 60],
                buffers: [0, 15, 30],
                plans: [],
                planIds: [],
                doctorMenuLabel: '',
                doctorMenuLabels: [],
                doctorMenu: {},
                isHideMatching: false,
                errors: {},
            }
        },

        computed: {
            /**
             * 従量課金用のメニューが含まれるかどうか
             * @return {boolean}
             */
            isIncludedPlanPayPer: function () {
                return this.plans.some((plan) => {
                    return this.planIds.includes(plan.id) && plan.key.includes(constants.plans.payPer)
                })
            },

            /**
             * 海外旅行ドクターパス用のメニューが含まれるかどうか
             * @return {boolean}
             */
            isIncludedPlanTravel: function () {
                return this.plans.some((plan) => {
                    return this.planIds.includes(plan.id) && plan.key.includes(constants.plans.travel)
                })
            },

            /**
             * 留学ドクターパス用のメニューが含まれるかどうか
             * @return {boolean}
             */
            isIncludedPlanStudyAbroad: function () {
                return this.plans.some((plan) => {
                    return this.planIds.includes(plan.id) && plan.key.includes(constants.plans.studyAbroad)
                })
            },

            /**
             * 定額プラン用のメニューが含まれるかどうか
             * @return {boolean}
             */
            isIncludedPlanFlatRate: function () {
                return this.plans.some((plan) => {
                    return this.planIds.includes(plan.id) && plan.key.includes(constants.plans.flatRate)
                })
            },

            /**
             * 選択可能プランにフィルタリング（無料版や団体向けプランなどを除外）
             * @return {array}
             */
            selectablePlans: function () {
                if (!this.plans) return []
                return this.plans.filter((plan) => constants.plans.common.includes(plan.key))
            },
        },

        watch: {
            // // おすすめメニューの制御
            // // @see https://github.com/sewii/Yokumiru/issues/533
            // // @see https://github.com/sewii/Yokumiru/issues/623
            // 'doctorMenu.is_auto': function (val) {
            //     if (val) {
            //         this.doctorMenu.consultation_minutes = 30
            //         this.doctorMenu.is_health_package = false
            //     }
            // },

            // 再相談可能メニューの制御
            // @see https://github.com/sewii/Yokumiru/issues/591
            // @see https://github.com/sewii/Yokumiru/issues/623
            'doctorMenu.is_repeatable': function (val) {
                if (!val) {
                    this.doctorMenu.repeat_consultation_price = null
                    this.doctorMenu.repeat_commission = null
                    this.doctorMenu.repeat_reservable_days = null
                    this.doctorMenu.is_only_repeatable = false
                }
            },
        },

        created: function () {
            this.fetchPlans()
            bus.$on('open-modal-admin-add-doctor-menu', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-admin-add-doctor-menu')
        },

        methods: {
            /**
             * プラン一覧取得
             */
            fetchPlans: function () {
                axios.get(constants.admin.plans.endpoint.base)
                    .then(({data}) => {
                        this.plans = data.data
                    })
            },

            /**
             * モーダル表示
             */
            open: function () {
                this.initDoctorMenu()
                this.initDoctorMenuLabel()
                this.modalShow = true
            },

            /**
             * モーダルを閉じる
             */
            close: function () {
                this.modalShow = false
                this.errors = {}
            },

            /**
             * 医師メニュー初期化
             */
            initDoctorMenu: function () {
                this.doctorMenu = {
                    title: null,
                    medical_course_id: null,
                    consultation_minutes: null,
                    after_buffer: 0,
                    before_buffer: 0,
                    consultation_price: null,
                    commission: null,
                    is_commission_tax: false,
                    description: null,
                    is_once: false,
                    is_auto: false,
                    is_health_package: false,
                    is_matching: true,
                    doctor_menu_labels: [],
                    is_repeatable: false,
                    is_only_repeatable: false,
                    repeat_consultation_price: null,
                    repeat_commission: null,
                    repeat_reservable_days: null,
                }
                this.isHideMatching = false
            },

            /**
             * 医師メニューラベルの初期化
             */
            initDoctorMenuLabel: function () {
                this.doctorMenuLabels = this.doctorMenu.doctor_menu_labels.map((lbl) => {
                    return {
                        id: lbl.id,
                        text: lbl.name,
                        style: 'color: #53A15B; background-color: #F3F8F2; border: 1px solid #DFEDDC;',
                    }
                })
            },

            /**
             * 医師メニューラベル追加時の同期処理
             *
             * @param {array} labels
             */
            syncDoctorMenuLabel: function (labels) {
                this.doctorMenuLabels = labels.map((lbl) => {
                    return {
                        text: lbl.text,
                        style: 'color: #53A15B; background-color: #F3F8F2; border: 1px solid #DFEDDC;',
                        tiClasses: ['ti-valid'], // VueTagsInputが自動生成している
                    }
                })
            },

            handleOk(e) {
                e.preventDefault()
                this.addDoctorMenu()
            },

            /**
             * 相談メニュー追加
             */
            addDoctorMenu: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const params = { ...this.doctorMenu }
                params.is_matching = !this.isHideMatching
                params.doctor_id = this.doctor.id
                params.doctor_menu_labels = this.doctorMenuLabels.length > 0 ? this.doctorMenuLabels.map((label) => label.text) : []
                params.plan_ids = []

                this.plans.forEach((plan) => {
                    if (!this.isIncludedPlanPayPer && plan.key.includes(constants.plans.payPer)) {
                        params.plan_ids.push(plan.id)
                    }
                    if (!this.isIncludedPlanTravel && plan.key.includes(constants.plans.travel)) {
                        params.plan_ids.push(plan.id)
                    }
                    if (!this.isIncludedPlanStudyAbroad && plan.key.includes(constants.plans.studyAbroad)) {
                        params.plan_ids.push(plan.id)
                    }
                    if (!this.isIncludedPlanFlatRate && plan.key.includes(constants.plans.flatRate)) {
                        params.plan_ids.push(plan.id)
                    }
                })

                // unique
                params.plan_ids = [...new Set(params.plan_ids)]

                // 国内版は診療終了後に料金確定なので固定値を入れる（国内版で参照されることはないデータ）
                if (this.$locale.type !== 'consul') {
                    params.consultation_price = 100
                    params.commission = 0
                    params.is_commission_tax = false
                }

                await axios.post(constants.admin.doctor_menus.endpoint.base, params)
                    .then(() => {
                        bus.$emit('alert-success', 'メニューを追加しました。')
                        bus.$emit('fetch-doctor-menus')
                        this.errors = {}
                        this.initDoctorMenu()
                        this.initDoctorMenuLabel()
                        this.close()
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },

            /**
             * 従量課金かどうか
             *
             * @param {object} plan
             * @return {boolean}
             */
            isPlanPayPer: function (plan) {
                return plan.key === constants.plans.payPer
            },

            /**
             * プラン制限チェックボックスのラベルを返す
             *
             * @param {object} plan
             * @return {string}
             */
            planCheckLabel: function (plan) {
                if (plan.key === constants.plans.payPer) {
                    return `通常の${this.$locale.consultation_host}メニューに表示しない`
                }
                return `${plan.name}に表示しない`
            },
        },
    }
</script>

<style lang="scss">
.modal-dialog {
    .vue-tags-input {
        max-width: 100%;
    }
}
</style>

<style lang="scss" scoped>
.checkboxList {
    input, label {
        cursor: pointer;
    }
}

.repeatReservableDaysPrefix {
    width: 124px;
}

.repeatReservableDaysInput {
    width: 76px;
}

.repeatReservableDaysSuffix {
    width: 54px;
    text-align: right;
}
</style>
